import React from "react";
import { Stack, Box, Chip, TextField, styled } from "@mui/material";
import AttachmentIcon from "@assets/attachment.png";

const GUTTER = 2;

const Container = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(GUTTER),
  gap: theme.spacing(GUTTER),
}));

export function EmailItem({ email }) {
  return (
    email && (
      <Container>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "100px 1fr",
            gap: GUTTER,
          }}
        >
          <LabelValueItem label="From" value={email["from"]} />
          <LabelValueItem label="To" value={email["to"]} />
          <LabelValueItem label="CC" value={email["cc"]} />
        </Box>
        <TextField
          variant="standard"
          value={email["subject"]}
          InputProps={{ readOnly: true }}
        />

        <Container>
          <div dangerouslySetInnerHTML={{ __html: email["body"] }} />
          {email["source_files"].map((file) => (
            <Box>
              <Chip
                avatar={<img src={AttachmentIcon} style={{}} />}
                label={file}
                variant="outlined"
              />
            </Box>
          ))}
        </Container>
      </Container>
    )
  );
}

function LabelValueItem({ label, value }) {
  return (
    <>
      <Chip variant="outlined" label={label} />
      <TextField
        variant="standard"
        value={value}
        InputProps={{ readOnly: true }}
      />
    </>
  );
}
